export function canvasToBlob(
  canvas: HTMLCanvasElement,
  format: string,
  quality: number,
) {
  return new Promise<Blob | null>((resolve) => {
    canvas.toBlob(resolve, format, quality)
  })
}
